import {Controller} from '@hotwired/stimulus';
import flatpickr from 'flatpickr';
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';

export default class extends Controller {
  static targets = ['item', 'month'];

  static values = {
    options: {type: Object, default: {}},
  };

  connect() {
    if (this.hasMonthTarget) {
      new flatpickr(this.element, Object.assign({
        plugins: [
          new monthSelectPlugin({
            shorthand: true,
            dateFormat: 'M Y',
            altFormat: 'F Y',
          })
        ],
        altInput: true,
        allowInput: true,
      }, this.optionsValue));

    } else {
      new flatpickr(this.element, Object.assign({
        dateFormat: 'd M Y',
        altInput: true,
        altFormat: 'd M Y',
        allowInput: true,
      }, this.optionsValue));

    }
  }

  disconnect() {
    this.element.flatpickr().destroy()
  }
}
